import { HTTP_INTERCEPTORS, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, BehaviorSubject, filter, catchError, switchMap, take, tap } from 'rxjs';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { TokenStorageService } from '../services/token-storage.service';
import { DataService } from '../services/data.service';
import { UserDTO } from '../interfaces/user';
import { RefreshTokenDTO } from '../interfaces/refreshToken';

const TOKEN_HEADER_KEY = 'Authorization';       // for Spring Boot back-end

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private user: UserDTO;
  private refreshToken: RefreshTokenDTO;

  constructor(private tokenService: TokenStorageService, private dataService: DataService) { }

  /*intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authReq = req;
    const token = this.token.getToken();
    if (token != null && token != "null") {
      authReq = req.clone({ headers: req.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token) });
    }
    return next.handle(authReq);
  }*/

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authReq = req;
    const token = this.tokenService.getToken();

    if (token && token !== 'null' && !req.url.includes('/auth/refreshToken')) {
      authReq = this.addTokenHeader(req, token);
    }

    return next.handle(authReq).pipe(
      catchError((error) => {
        // Controleer of de fout een 401 status is én dat het niet de refresh-endpoint zelf was
        if (
          error instanceof HttpErrorResponse &&
          error.status === 401 &&
          !req.url.includes('/api/refresh')
        ) {
          return this.handle401Error(authReq, next);
        }

        return throwError(() => error);
      })
    );
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      const refreshToken = this.tokenService.getRefreshToken();
      const deviceId = this.tokenService.getDeviceId();

      if (refreshToken && deviceId) {
        return this.dataService.refreshToken(refreshToken, deviceId).pipe(
          tap((data: UserDTO) => {
            this.user = data;
            this.isRefreshing = false;
            
            // Sla zowel Access Token als nieuw Refresh Token op
            this.tokenService.saveToken(this.user.accessToken);
            if (this.user.refreshToken) {
              this.tokenService.saveRefreshToken(this.user.refreshToken);
            }

            // Breng eventuele wachtende requests op de hoogte
            this.refreshTokenSubject.next(this.user.accessToken);
          }),
          switchMap(() => {
            // Herhaal het originele request met het NIEUWE token
            return next.handle(this.addTokenHeader(request, this.user.accessToken));
          }),
          catchError((err) => {
            this.isRefreshing = false;
            this.tokenService.signOut();
            return throwError(() => err);
          })
        );
      } else {
        this.isRefreshing = false;
        this.tokenService.signOut();
        return throwError(() => new Error('No refresh token available'));
      }
    } else {
      // Wacht tot de huidige refresh actie klaar is
      return this.refreshTokenSubject.pipe(
        filter(token => token !== null),
        take(1),
        switchMap(token => next.handle(this.addTokenHeader(request, token)))
      );
    }
  }

  private addTokenHeader(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      headers: request.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token)
    });
  }
}

export const authInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
];